export default {
      id: "ic_tribun_users-usage",
      viewBox: "0 0 35 25",
      url: "/" + "images/icons.3.109.2.svg#ic_tribun_users-usage",
      toString: function () {
        return this.url;
      }
    }